"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.impossiblePersonalAutoPolicySchema = void 0;
const zod_1 = require("zod");
const Policy_1 = require("./Policy");
const AtFaultTypes_1 = require("../enums/AtFaultTypes");
const Operator_1 = require("./Operator");
const PersonalAutoDiscount_1 = require("./PersonalAutoDiscount");
const PersonalAutoIncident_1 = require("./PersonalAutoIncident");
const Vehicle_1 = require("./Vehicle");
const numbers_1 = require("../numbers");
exports.impossiblePersonalAutoPolicySchema = Policy_1.impossiblePolicySchema.extend({
    operators: zod_1.z.array(Operator_1.impossibleOperatorSchema).min(1),
    vehicles: zod_1.z.array(Vehicle_1.impossibleVehicleSchema).min(1),
    discounts: zod_1.z.array(PersonalAutoDiscount_1.impossiblePersonalAutoDiscountSchema).optional(),
    hasAtFaultAccident: zod_1.z.nativeEnum(AtFaultTypes_1.AtFaultTypes),
    hasAtFaultClaim: zod_1.z.optional(zod_1.z.nativeEnum(AtFaultTypes_1.AtFaultTypes)),
    incidents: zod_1.z.array(PersonalAutoIncident_1.impossiblePersonalAutoIncidentSchema),
    premiumCents: zod_1.z.number().gt(0).lt((0, numbers_1.million)(5)),
}).strict();
